import ActionUtility from "../../utilities/ActionUtility";
import IAction from "../../models/IAction";

export default class ConfigActions {
    public static readonly CONFIG_SET_IS_IE: string = "ConfigActions.CONFIG_SET_IS_IE";

    public static readonly CONFIG_SET_IS_SAFARI: string = "ConfigActions.CONFIG_SET_IS_SAFARI";

    public static readonly CONFIG_SET_EMBEDDED_MODE: string = "ConfigActions.CONFIG_SET_EMBEDDED_MODE";

    public static readonly REQUEST_SIMULAZIONE_SET_SEARCH_ON_FOCUS: string =
        "AgendaAction.REQUEST_SIMULAZIONE_SET_SEARCH_ON_FOCUS";

    public static setIsIE(isIE: boolean): IAction<boolean> {
        return ActionUtility.createAction(ConfigActions.CONFIG_SET_IS_IE, isIE);
    }

    public static setIsSafari(isSafari: boolean): IAction<boolean> {
        return ActionUtility.createAction(ConfigActions.CONFIG_SET_IS_SAFARI, isSafari);
    }
    public static setEmbeddedMode(embeddedMode: boolean): IAction<boolean> {
        return ActionUtility.createAction(ConfigActions.CONFIG_SET_EMBEDDED_MODE, embeddedMode);
    }

    public static setSearchOnFocus(onFocus: boolean): any {
        return ActionUtility.createAction(ConfigActions.REQUEST_SIMULAZIONE_SET_SEARCH_ON_FOCUS, onFocus);
    }
}
